import $ from 'jquery';

const switcherContent = {
	init: () => {
		const switcherNavigationButtons = $('.js-switcher-navigation-item');
		// const contentItems = $('.js-switcher-content-item');
		switcherNavigationButtons.on('click', function(e) {
			const $this = $(this),
			$siblings = $this.parent().children(),
			position = $siblings.index($this),
			contentItems = $this.parent().parent().find('.js-switcher-content-item');
			e.preventDefault();
			if($this.closest('.contact-content').length > 0) {
				$('body').addClass('model-open-mobile');
			}

			$siblings.removeClass('active mobile-active');
			$this.addClass('active mobile-active');

			setTimeout(function() {
				contentItems.removeClass('active mobile-active').eq(position).addClass('active mobile-active');
			}, 300)
			$('.js-back-to-contact').click(function() {


				$siblings.removeClass('active mobile-active');
				setTimeout(function() {
					contentItems.removeClass('active mobile-active');
					$('body').removeClass('model-open-mobile');
				}, 300)
			})

		})
	},

	switchBySpecificId () {

		const switcherNavigationButtons = $('.js-switcher-by-id-navigation-item');

		switcherNavigationButtons.on('click', function(e) {
			const $this = $(this),
			siblings = $this.parent().children(),
			position = $this.data('tab-id'),
			productType = $this.data('product-type'),
			contentItems = $this.parent().parent().find('.js-switcher-content-item');
			e.preventDefault();
			if($this.closest('.contact-content').length > 0) {
				$('body').addClass('model-open-mobile');
			}

			siblings.removeClass('active mobile-active');
			$this.addClass('active mobile-active');

			setTimeout(function() {
				contentItems.removeClass('active mobile-active')
				$(`.js-switcher-content-item[data-tab-id="${position}"]`).addClass('active mobile-active').attr('data-product-type', productType);

			}, 300)
	})
}
}

export default switcherContent;